<!-- 購入フローの中で段階の表示を行うヘッダー -->
<template>
  <ul class="flow">
    <li :class="[page === '1' ? 'active' : '']">
      <label>{{ is0yenTicket ? "取得情報入力" : "購入情報入力" }}</label>
    </li>
    <li :class="[page === '2' ? 'active' : '']">
      <label>内容の確認</label>
    </li>
    <li :class="[page === '3' ? 'active' : '']">
      <label>完了</label>
    </li>
  </ul>
</template>

<script>
export default {
  name: "TheStoreHeader",
  props: {
    page: {
      type: String,
      required: true,
    },
    is0yenTicket: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
<style lang="scss" scoped>
.flow {
  display: flex;
  margin-top: calc(30px + env(safe-area-inset-top, 30px) + 30px);
  background-color: #f0f0f0;
  list-style: none;
  font-size: 13px;
  font-weight: bold;
  height: 45px;
  overflow: hidden;
}

.flow li {
  position: relative;

  height: 45px;
  margin-left: -25px;
  background-color: #f0f0f0;
  line-height: 45px;
  color: #999999;
}

.flow li:nth-child(1) {
  width: calc(100% / 3 + 25px + 25px);
}

.flow li:nth-child(1) label {
  width: calc(100% - 28px - 10px);
}

.flow li:nth-child(2) {
  width: calc(100% / 3 + 25px);
}

.flow li:nth-child(3) {
  width: calc(100% / 3 + 25px);
}

.flow li label {
  position: absolute;
  width: calc(100% - 28px - 20px);
  padding-left: 25px;
  background-color: #e0e0e0;
  text-align: center;
  z-index: 1500;
  height: 45px;
}

.flow li:after {
  position: absolute;
  z-index: 2000;
  display: block;
  top: 6px;
  right: 6px;
  content: "";
  width: 32px;
  height: 32px;
  border-width: 1px 1px 0 0;
  border-style: solid;
  border-color: #ffffff;
  background: -webkit-linear-gradient(
    45deg,
    transparent 20px,
    #e0e0e0 1px,
    #e0e0e0 25px
  );
  transform: rotate(45deg);
}

.flow li.active:after {
  background: -webkit-linear-gradient(
    45deg,
    transparent 20px,
    #ffb206 1px,
    #ffb206 25px
  );
}

.flow li.active {
  color: #ffffff;
}

.flow li.active label {
  background-color: #ffb206;
}
</style>
